<script>
  import { BaseTransition } from '@roxi/routify/decorators';
  import { cubicOut } from 'svelte/easing';

  export function flyCustom(node, { delay = 0, duration = 400, easing = cubicOut, x = 0, y = 0 }) {
    const style = getComputedStyle(node);
    const transform = style.transform === 'none' ? '' : style.transform;
    return {
      delay,
      duration,
      easing,
      css: (t, u) => `transform: ${transform} translate(${(1 - t) * x}px, ${(1 - t) * y}px);`,
    };
  }

  export let scoped;
  const { width } = scoped;
  const transitionDuration = 400;
  const configs = [
    {
      condition: ({ routes }) => routes[0] === routes[1],
      transition: () => {},
    },
    {
      condition: (c) => c.toHigherIndex,
      transition: flyCustom,
      inParams: { x: $width, duration: transitionDuration, easing: cubicOut },
      outParams: { x: -$width, duration: transitionDuration, easing: cubicOut },
    },
    {
      condition: (c) => c.toLowerIndex,
      transition: flyCustom,
      inParams: { x: -$width, duration: transitionDuration, easing: cubicOut },
      outParams: { x: $width, duration: transitionDuration, easing: cubicOut },
    },
    {
      // No matching config. We don't want a transition
      condition: () => true,
    },
  ];
</script>

<BaseTransition {configs}>
  <slot />
</BaseTransition>
